// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3i63O","noCharacters":"styles_noCharacters__3dzQF"};